<template>
  <div class="td-user-day" @click="setCreateEventOnUser" :class="{'td-user-day--active': isTheActiveDay}">
    <div class="do-events">
      <div class="do-events__event do-events__event--edit" @click.stop="editEvent(event)"
           v-for="event in filteredEvents"
           :key="event.event_id"
           :style="{backgroundColor: event.color}">
        {{ event.v_time }}
      </div>
      <button class="bttn bttn--small btn-trans do-events__event__add-event">
        + Tilføj vagt
      </button>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import ButtonSpinner from '../common/ButtonSpinner.vue'

export default {
  components: {ButtonSpinner},
  props: {
    user: {
      type: Object
    },
    date: {
      default: () => new Date()
    },
    eventsInHash: {
      default: {}
    },
    subjectsInUserCalIdHash: {},
    theCreateEventObj: {
      type: Object,
      default: null
    }
  },
  computed: {
    filteredEvents () {
      const calendarId = this.user.user_calendar_id
      const lookUpKey = `${calendarId}_${moment(this.date).format('YYYY_MM_DD')}`
      return this.eventsInHash[lookUpKey] ? this.eventsInHash[lookUpKey] : []
    },
    isTheActiveDay () {
      if (!this.theCreateEventObj) {
        return false
      }
      return this.theCreateEventObj.user.id === this.user.id && this.theCreateEventObj.date === this.date
    }
  },
  methods: {
    setCreateEventOnUser () {
      const calendarId = this.user.user_calendar_id
      const subject = this.subjectsInUserCalIdHash[calendarId]
      const newEventObj = {
        user: this.user,
        date: this.date,
        subject: subject
      }
      this.$emit('createEvent', newEventObj)
    },
    editEvent (event) {
      const editEventObj = {
        user: this.user,
        event: event
      }
      this.$emit('editEvent', editEventObj)
    }
  }
}
</script>

<style scoped>

.td-user-day {
  height: 100%;
  width: 100%;
  cursor: pointer;
  padding: 0.25rem;
}

.do-events {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.do-events__event {
  text-align: center;
  color: #fff;
  width: 100%;
  height: 100%;
  padding: 1px 3px 1px 8px;
  z-index: 1;
  overflow: hidden;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
}

.do-events__event__add-event{
  cursor: pointer;
  font-weight: 100 !important;
  opacity: 0.65;
}

.do-events__event__add-event:hover{
  background: #f0f8ff;
  opacity: 1;
}

.do-events__event + .do-events__event__add-event {
  opacity: 0.15;
}

.td-user-day:hover .do-events__event + .do-events__event__add-event {
  opacity: 1;
}


</style>



// WEBPACK FOOTER //
// DutySchedulePlanCalendarUserDay.vue?a7365676